import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addFaq } from "../../redux/slices/dashboard";
import { toast } from "react-toastify";

function CreateFaq(props) {
  const [question, setQuestion] = useState("");
  const [answer, setAnswer] = useState("");
  const [annotations, setAnnotations] = useState([]);
  const dispatch = useDispatch();
  const handleSubmit = () => {
    const regex = /^\S.*\S$/;

    if (!regex.test(question) || !question || question.trim().length < 2) {
      toast.error(
        "Please enter a question with at least 2 letters and no white spaces"
      );
      return;
    }

    if (!regex.test(answer) || !answer || answer.trim().length < 2) {
      toast.error(
        "Please enter a question with at least 2 letters and no white spaces"
      );
      return;
    }

    let params = {
      question: question,
      answer: answer,
      annotations: annotations,
    };
    dispatch(
      addFaq({
        ...params,
        cb(res) {
          if (res.status === 200) {
            props?.close();
            props?.faqList();
          } else {
            console.log("there is some error in the faq");
          }
        },
      })
    );
  };

  return (
    <>
      <div>
        <div className="guideForm mb-3">
          <label className="">Question</label>
          <input
            class="form-control customFormControl"
            type="text"
            placeholder="Enter your Question"
            value={question}
            onChange={(e) => setQuestion(e.target.value)}
          />
        </div>

        <div className="guideForm mb-3">
          <label className="">Answer</label>
          <input
            class="form-control customFormControl"
            type="text"
            placeholder="Enter your Answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
          />
        </div>

        <div className="outer-btn mb-3">
          <button onClick={handleSubmit} className=" submit-btn">
            Submit
          </button>
        </div>
      </div>
    </>
  );
}

export default CreateFaq;
